module.exports = __webpack_public_path__ + "img/pano-modelo.b14dc875.jpg";